"use strict";
// Notification Database Record Types
// Based on actual DynamoDB writes in lambda-secure/src/services/notifications.ts
Object.defineProperty(exports, "__esModule", { value: true });
